interface BuildShareLinkParams {
	fileId: string;
	recipientEmail: string;
	senderOrgId: string;
	recipientOrgType: "lab" | "med" | null;
	dentconnectUrl: string;
	jobId?: number | string;
}

export function buildShareLink({
	fileId,
	recipientEmail,
	senderOrgId,
	recipientOrgType,
	dentconnectUrl,
	jobId,
}: BuildShareLinkParams): string {
	// Lab recipients use the current origin because this function is only called from
	// dentLAB — so window.location.origin IS the correct dentLAB URL, avoiding a
	// separate VITE_DENTLAB_URL env var. Med recipients get the dentCONNECT URL.
	const baseUrl =
		recipientOrgType === "lab"
			? window.location.origin
			: dentconnectUrl;

	const path = jobId
		? `/vendor/${senderOrgId}/job/${jobId}`
		: `/vendor/${senderOrgId}/invoices`;

	const params = new URLSearchParams({
		file: fileId,
		email: recipientEmail,
		...(recipientOrgType === "lab" && { login: "kommunikation" }),
	});

	return `${baseUrl}${path}?${params.toString()}`;
}
